/**
 * Kantenschutz (AngleSection): Schnitt-Normalisierung und Legacy-Symbol-String fürs PDF/DXF.
 * Symbole entsprechen dem früheren AngleSection.calcSign (react / oldCode).
 */

export type AngleSectionCutsShape = {
  left: { bottom: boolean; top: boolean };
  right: { bottom: boolean; top: boolean };
};

/**
 * Normalisiert Schnitte: 180°-Rotation gilt als gleiche Konfiguration.
 */
export function normalizeCuts(
  cuts: AngleSectionCutsShape,
): AngleSectionCutsShape {
  const originalKey = `${cuts.left.bottom ? "1" : "0"}${cuts.left.top ? "1" : "0"}${cuts.right.bottom ? "1" : "0"}${cuts.right.top ? "1" : "0"}`;

  const rotatedCuts: AngleSectionCutsShape = {
    left: {
      bottom: cuts.right.top,
      top: cuts.right.bottom,
    },
    right: {
      bottom: cuts.left.top,
      top: cuts.left.bottom,
    },
  };
  const rotatedKey = `${rotatedCuts.left.bottom ? "1" : "0"}${rotatedCuts.left.top ? "1" : "0"}${rotatedCuts.right.bottom ? "1" : "0"}${rotatedCuts.right.top ? "1" : "0"}`;

  if (originalKey <= rotatedKey) {
    return cuts;
  }
  return rotatedCuts;
}

export function normalizeCutsKey(cuts: AngleSectionCutsShape): string {
  const normalized = normalizeCuts(cuts);
  return `${normalized.left.bottom ? "1" : "0"}${normalized.left.top ? "1" : "0"}${normalized.right.bottom ? "1" : "0"}${normalized.right.top ? "1" : "0"}`;
}

/**
 * Text-Symbol für die Schnitt-Konfiguration (für Tabellen / DXF).
 * Reihenfolge der if-Blöcke wie im Legacy calcSign.
 */
export function getAngleSectionCutSign(
  cuts: AngleSectionCutsShape | undefined,
): string {
  if (!cuts) return "";

  let res = "";
  if (cuts.left.top && cuts.right.top) {
    res = "/ \\";
  }
  if (cuts.left.bottom && cuts.right.bottom) {
    res = "/ \\";
  }
  if (cuts.left.top && cuts.left.bottom) {
    res = "v";
  }
  if (cuts.right.top && cuts.right.bottom) {
    if (res === "v") {
      res = "< >";
    } else {
      res = "v";
    }
  }
  return res;
}
